import React from 'react'
import { Tooltip } from '@mui/material';
import style from './sheet-item.module.css';
import { FileResponse } from '../interfaces/FileResponse';
import { ChevronLeftIcon, ChevronRightIcon, ChevronsLeftIcon, ChevronsRightIcon, IconProps, TrashIcon } from '../icons/icons';


export interface MovementButtonProps {
    buttonType: MovementType,
    onClick: (file: FileResponse) => Promise<any>,
    current: FileResponse
}

export enum MovementType {
    Up,
    Down,
    First,
    Last,
    Remove
}

const BUTTON_CONFIG: Record<MovementType, { Icon: React.ComponentType<IconProps>; tip: string }> = {
    [MovementType.Up]:     { Icon: ChevronLeftIcon,   tip: 'Mover partitura para frente' },
    [MovementType.First]:  { Icon: ChevronsLeftIcon,  tip: 'Mover partitura para primeira posição' },
    [MovementType.Down]:   { Icon: ChevronRightIcon,  tip: 'Mover partitura para trás' },
    [MovementType.Last]:   { Icon: ChevronsRightIcon, tip: 'Mover partitura para última posição' },
    [MovementType.Remove]: { Icon: TrashIcon,         tip: 'Excluir do repertório' },
};

export default function MovementButton({ buttonType, current, onClick }: MovementButtonProps) {

    const { Icon, tip } = BUTTON_CONFIG[buttonType];
    const danger = buttonType === MovementType.Remove;

    return <Tooltip title={tip} arrow>
        <button
            type='button'
            className={danger ? `${style.navigationButton} ${style.navigationButtonDanger}` : style.navigationButton}
            aria-label={tip}
            onClick={async () => await onClick(current)}
        >
            <Icon size={20} />
        </button>
    </Tooltip>
}
